import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "../../../common/commonService";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-pdf-company-preview-proforma-invoice",
  templateUrl: "./pdf-company-preview-proforma-invoice.component.html",
  styleUrls: ["./pdf-company-preview-proforma-invoice.component.scss"],
})
export class PdfCompanyPreviewProformaInvoiceComponent implements OnInit {
  company;

  @Input("company") set _company(company) {
    this.company = company;
  }
  constructor(
    public sanitizer: DomSanitizer,
    public _CommonService: CommonService
  ) {}

  ngOnInit() {
    console.log(this.company, "ccc");
  }
}
